import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: theme.spacings.md,
  },
  leftCol: {
    justifyContent: 'space-between',
  },
  ceImageWrapper: {
    width: 48,
  },
  ceImage: {
    width: '100%',
  },
  semiboldBase: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
  },
  semiboldLg: {
    fontSize: theme.fontSizes.lg,
    fontWeight: '600',
  },
});
